import { environment } from 'environments/environment';

/**
 * Devuelve la URL visualizable de una imagen guardada en belivfiles.
 *
 * Los valores nuevos son solo el nombre del archivo en el storage (lo que
 * devuelve FileService.uploadBlob), por lo que se arma la URL de
 * visualize-blob con la api key (?code=) que necesitan <img> y background-image.
 * Los valores viejos (URL absoluta, data:, blob:, /ruta o assets/) se
 * devuelven tal cual para no romper lo que ya está guardado.
 *
 * @param value Nombre del archivo en el storage o URL ya armada
 * @param apiKey Api key de belivfiles (AuthenticationTypeService.getApiKey)
 */
export function fileVisualizeUrl(value?: string | null, apiKey: string = ''): string | undefined {
  const file = (value || '').trim();
  if (!file) return undefined;
  if (/^(https?:|data:|blob:|\/|assets\/)/i.test(file)) return file;
  return `${environment.bpmApiUrl}/api/files/visualize-blob/${file}${apiKey ? `?code=${apiKey}` : ''}`;
}
